import React from "react";
import { Radio, RadioGroup, Input } from "@heroui/react";
import { Hash, SlidersHorizontal } from "@phosphor-icons/react";

interface Participant {
  id: string;
  name: string;
  firstName?: string;
}

interface TemplateParam {
  key: string;
  isGlobal: boolean;
  globalValue: string;
  personalValues: Record<string, string>;
}

interface ParameterSectionProps {
  templateParams: TemplateParam[];
  participants: Participant[];
  toggleParamGlobal: (paramKey: string) => void;
  handleGlobalParamChange: (paramKey: string, value: string) => void;
  handlePersonalParamChange: (
    paramKey: string,
    participantId: string,
    value: string,
  ) => void;
}

const ParameterSection: React.FC<ParameterSectionProps> = ({
  templateParams,
  participants,
  toggleParamGlobal,
  handleGlobalParamChange,
  handlePersonalParamChange,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1 font-medium">
        <SlidersHorizontal size={18} weight="duotone" />
        <p>Parameters</p>
      </div>
      {templateParams.map((param) => (
        <div
          key={param.key}
          className="flex flex-col gap-4 rounded-lg border border-neutral-primary/20 p-3"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1 font-medium">
              <Hash size={18} weight="duotone" />
              <p>Parameter {`{{${param.key}}}`}</p>
            </div>
            <RadioGroup
              orientation="horizontal"
              color="success"
              value={param.isGlobal ? "global" : "individual"}
              onValueChange={() => toggleParamGlobal(param.key)}
            >
              <Radio value="global">Voor iedereen</Radio>
              <Radio value="individual">Individueel</Radio>
            </RadioGroup>
          </div>
          {param.isGlobal ? (
            <Input
              value={param.globalValue}
              onChange={(e) =>
                handleGlobalParamChange(param.key, e.target.value)
              }
              placeholder={`Globale waarde voor {{${param.key}}}`}
              classNames={{
                input:
                  "text-neutral-primary placeholder:text-neutral-secondary-mid",
                inputWrapper:
                  "p-2.5 min-h-fit h-fit rounded-sm bg-white shadow-form-element! data-[hover=true]:bg-white group-data-[focus=true]:bg-white data-[hover=true]:shadow-form-element-hv! group-data-[focus=true]:shadow-form-element-fc!",
              }}
            />
          ) : (
            <div className="flex flex-col gap-3">
              {participants.map((participant) => (
                <Input
                  value={
                    param.key === "1"
                      ? participant.firstName ||
                        param.personalValues[participant.id] ||
                        ""
                      : param.personalValues[participant.id] || ""
                  }
                  onChange={(e) =>
                    handlePersonalParamChange(
                      param.key,
                      participant.id,
                      e.target.value,
                    )
                  }
                  placeholder={`Waarde voor {{${param.key}}} (${participant.name})`}
                  classNames={{
                    input:
                      "text-neutral-primary placeholder:text-neutral-secondary-mid",
                    inputWrapper:
                      "p-2.5 min-h-fit h-fit rounded-sm bg-white shadow-form-element! data-[hover=true]:bg-white group-data-[focus=true]:bg-white data-[hover=true]:shadow-form-element-hv! group-data-[focus=true]:shadow-form-element-fc!",
                  }}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ParameterSection;
